<template>
    <div class="answer-list-content answer-list-products">

        <!-- ----------------------------------------- -->
        <!-- PRODUCT LIST -->
        <!-- ----------------------------------------- -->

        <div v-if="getProductList && getProductList.length > 1" class="answer-items">
                <div v-for="product in getProductList"
                     :key="product.code"
                     :ref="'answer-item-'+product.code"
                     class="answer-item"
                >
                    <div v-if="product.productStatusType === 'ACTIVE'"
                         @click.once="handleClickProduct(product)"
                         :id="'M_' + product.code"
                    >
                        <span class="answer-item-text" >{{product.name}}</span>
                    </div>
                    <div v-else>
                        <div class="answer-item-text chatbot-product-inactive">
                            <div>{{product.name}}</div>
                            <div v-if="product.productStatusType === 'NOT_YET_ACTIVE'" class="no-active-product">{{text('api.error.product.activation.period.not.started', [product.productStatusDate])}}</div>
                            <div v-if="product.productStatusType === 'EXPIRED'" class="no-active-product">{{text('api.error.product.activation.period.expired', [product.productStatusDate])}}</div>
                            <div v-if="product.productStatusType === 'UNRELEASED'" class="no-active-product">{{text('api.error.product.not.released', [product.productStatusDate])}}</div>
                            <div v-if="product.productStatusType === 'USER_DEACTIVATED'" class="no-active-product">{{text('api.error.product.activation.period.expired', [product.productStatusDate])}}</div>
                        </div>
                    </div>
                </div>
        </div>

        <div  v-if="getProductList && getProductList.length === 1" v-for="product in getProductList" :key="product.code" class="btn-eval">
            <v-btn @click.once="handleClickProduct(product)"
                   :id="'M_' + product.code"
                   class="btn"
                   color="primary"
                   block
            >
                {{text("api.chatbot.btn.startAssessment")}}
                <span>
                    <ce-icon :svg-fill-class="'svg-on-primary-color'" class="ce-logo-header" style="top: 3px;margin-left: 3px;"></ce-icon>
                </span>
            </v-btn>
        </div>



    </div>
</template>

<!-- ################################################################## -->

<script>
    import { mapGetters } from 'vuex';
    import CeIcon from "../../../../common/components/svg/info-popup/ceIcon";

    export default {
        name: 'AnswerListProducts',
        components: {CeIcon},
        data() {
            return {
                isClickDisabled: false, // This will help us to prevent multiple clicks/multiple answers.
            };
        },
        computed: {
            ...mapGetters({
                getProductList: 'ChatBotStore/getProductList',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
            })
        },

        updated: function () {
            this.isClickDisabled = false; // Answer list has been updated (we have a new set of answers), so we make sure that clicks are enabled.
        },

        watch: {
            getProductList (newVal, oldVal) {

                if (newVal !== null && newVal.length > 0) {
                    this.$nextTick(function () {
                        this.$emit('onProductListUpdated');
                    });
                }

            }
        },

        methods: {

            handleClickProduct (clickedProduct) {

                if (this.isClickDisabled === true) {
                    return; // Clicks are disabled, so do nothing else.
                }
                else {
                    this.isClickDisabled = true; // Clicks were enabled until now. We disable them now (so no other clicks are possible), then execute the actions for current click.
                }

                if (this.getProductList.length > 1) {
                    let clickedAnswerElem = this.$refs['answer-item-' + clickedProduct.code][0];
                    clickedAnswerElem.classList.add('answer-item-clicked');
                }

                document.querySelector(".chatbot-page-content .chatbot-conversation-msg-list").classList.add("animate-fade-out-conversaion-list");

                setTimeout(() => {

                    this.PfChatbotPlugin.hideAnswerList();

                    this.$store.commit('ChatBotStore/setMoreContentAvailable', false); // Hide "More Content" icon.

                    this.$store.dispatch("ChatBotStore/selectProduct", clickedProduct).then(() => {
                        // Redirect to Medical Device's URL.
                        this.$router.push({name: 'PF_AssessmentPage'});
                    });

                }, 500);

            }

        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .btn-eval {
        text-align: center !important;
    }

    .answer-item-text.chatbot-product-inactive {
        color: $color-headings-text;
        cursor: default !important;
        height: 68px !important;

        .no-active-product {
            color: $color-element-outline;
        }
        div {
            height: 0 !important;
        }
    }

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/answer-list/AnswerListProducts.vue